import { ControlledMenu, MenuDivider, MenuItem, SubMenu } from "@szhsin/react-menu";
import { g } from "analytics";
import { commandProcessor } from "command/command";
import clipboard from "editing/clipboard";
import { deleteSelected } from "editing/deleting";
import { t } from "i18next";
import { ReorderItems } from "ordering/actions";
import React from "react";
export class EditorContextMenu extends React.Component {
    constructor() {
        super(...arguments);
        this.reorderAction = (action) => {
            let command = ReorderItems.create(this.extractSelectedIds(), action);
            if (command) {
                g("LayerOrdering", action.capitalise() + "-ContextMenu");
                commandProcessor.execute(command);
            }
        };
    }
    render() {
        const itemsSelected = !this.props.selected.isEmpty;
        return React.createElement(ControlledMenu, { key: "ContextMenu", anchorPoint: this.props.contextMenu ? this.props.contextMenu.position : { x: 0, y: 0 }, state: this.props.contextMenu !== undefined ? "open" : "closed", onClose: () => this.props.onClose() },
            React.createElement(MenuItem, { key: "Cut", onClick: () => clipboard.cut("contextmenu"), disabled: !itemsSelected },
                React.createElement("i", { className: "fas fa-cut" }),
                t("Cut")),
            React.createElement(MenuItem, { key: "Copy", onClick: () => clipboard.copy("contextmenu"), disabled: !itemsSelected },
                React.createElement("i", { className: "far fa-copy" }),
                t("Copy")),
            React.createElement(MenuItem, { key: "Paste", onClick: () => clipboard.paste("contextmenu") },
                React.createElement("i", { className: "far fa-clipboard" }),
                t("Paste")),
            React.createElement(MenuItem, { key: "PasteInPlace", onClick: () => clipboard.paste("contextmenu", { inPlace: true }) }, t("Paste in place")),
            React.createElement(MenuDivider, null),
            this.groupUngroupSection(),
            React.createElement(MenuDivider, null),
            React.createElement(SubMenu, { label: t("Order"), disabled: !itemsSelected, offsetX: -4 },
                React.createElement(MenuItem, { onClick: () => this.reorderAction("bringToFront") },
                    React.createElement("i", { className: "fad fa-bring-front" }),
                    t("ui.Bring to front")),
                React.createElement(MenuItem, { onClick: () => this.reorderAction("bringForward") },
                    React.createElement("i", { className: "fad fa-bring-forward" }),
                    t("ui.Bring forward")),
                React.createElement(MenuItem, { onClick: () => this.reorderAction("sendBackward") },
                    React.createElement("i", { className: "fad fa-send-backward" }),
                    t("ui.Send backward")),
                React.createElement(MenuItem, { onClick: () => this.reorderAction("sendToBack") },
                    React.createElement("i", { className: "fad fa-send-back" }),
                    t("ui.Send to back"))),
            React.createElement(MenuDivider, null),
            React.createElement(MenuItem, { key: "Delete", onClick: () => deleteSelected("contextmenu"), disabled: !itemsSelected },
                React.createElement("i", { className: "far fa-trash-alt" }),
                t("Delete")));
    }
    groupUngroupSection() {
        const children = [];
        if (this.props.selected.shouldAllowUngrouping) {
            children.push(React.createElement(MenuItem, { key: "Ungroup", onClick: () => {
                    const command = this.props.selected.createUngroupObjectsCommand();
                    if (command) {
                        g("Grouping", "Ungroup-ContextMenu");
                        commandProcessor.execute(command);
                    }
                } },
                React.createElement("i", { className: "far fa-object-ungroup" }),
                t("ui.Ungroup objects")));
        }
        if (this.props.selected.shouldAllowRegrouping) {
            children.push(React.createElement(MenuItem, { key: "Regroup", onClick: () => {
                    const command = this.props.selected.createRegroupObjectsCommand();
                    if (command) {
                        g("Grouping", "Regroup-ContextMenu");
                        commandProcessor.execute(command);
                    }
                } },
                React.createElement("i", { className: "fad fa-object-group" }),
                t("ui.Regroup object")));
        }
        if (children.length == 0 || this.props.selected.shouldAllowGrouping) {
            // Ensure there is at least one button: Group.
            children.unshift(React.createElement(MenuItem, { key: "Group", disabled: !this.props.selected.shouldAllowGrouping, onClick: () => {
                    const command = this.props.selected.createGroupObjectsCommand();
                    if (command) {
                        g("Grouping", "Group-ContextMenu");
                        commandProcessor.execute(command);
                    }
                } },
                React.createElement("i", { className: "far fa-object-group" }),
                t("ui.Group objects")));
        }
        return children;
    }
    extractSelectedIds() {
        return this.props.selected.items.map(a => a.id);
    }
}
